import { render, staticRenderFns } from "./FilterOptionTapirMd.vue?vue&type=template&id=428d47fc&scoped=true&"
import script from "./FilterOptionTapirMd.vue?vue&type=script&lang=js&"
export * from "./FilterOptionTapirMd.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionTapirMd.vue?vue&type=style&index=0&id=428d47fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d47fc",
  null
  
)

export default component.exports